import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApartmentsComponent } from './apartments.component';
import { AddNewApartmentsComponent } from './add-new-apartments/add-new-apartments.component';
import { ApartmentDetailsComponent } from './apartment-details/apartment-details.component';
import { ContractComponent } from './contract/contract.component';
import { CreateContractComponent } from './contract/create-contract/create-contract.component';
import { BookingComponent } from './booking/booking.component';
import { ViewBookingComponent } from './view-booking/view-booking.component';
import { HandoverFlowComponent } from './handover-flow/handover-flow.component';
import { HandoverdetailsComponent } from './handover-flow/handoverdetails/handoverdetails.component';
import { AddNewHandoverComponent } from './handover-flow/add-new-handover/add-new-handover.component';
 



const routes: Routes = [
  {
    path: '', component: ApartmentsComponent
  },
  {
    path: 'Add-NewApartments', component: AddNewApartmentsComponent
  },
  {
    path: 'page/:id',
    component: AddNewApartmentsComponent
  },
  {
    path: 'apartments-details/:id',
    component: ApartmentDetailsComponent
  },
  {
    path: ':id',
    component: ContractComponent
  },
  {
    path: 'contract/:id',
    component: CreateContractComponent
  },
  {
    path: 'booking/:id',
    component: BookingComponent
  },
  {
    path: 'view-booking/:id',
    component: ViewBookingComponent
  },
 
  {
    path: 'handover-flow/:id',
    component: HandoverFlowComponent
  },

  {
    path: 'handover-details/:id',
    component: HandoverdetailsComponent
  },
   {
    path: 'add-new-handover/:id',
    component: AddNewHandoverComponent
  },






  
  
   
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApartmentsRoutingModule { }

